// src/components/HeroSection.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../assets/background.jpeg";
import secondImage from "../assets/second.jpg";
import Blogs from "../Blogs/Blogs";

/* Reusable hero block */
function HeroBlock({
  bgImage,
  ariaLabel,
  align = "left", // "left" | "center"
  title,
  name,
  lines = [],
  buttonText,
  onButtonClick,
  minHeights = {
    base: "min-h-[54vh]",
    sm: "sm:min-h-[60vh]",
    lg: "lg:min-h-[70vh]",
  },
}) {
  const alignWrap = align === "center" ? "text-center w-full" : "text-left";
  const alignContainer =
    align === "center" ? "items-center justify-center" : "items-center";

  return (
    <section
      className="relative w-full overflow-hidden"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
      aria-label={ariaLabel}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Content */}
      <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div
          className={`flex ${minHeights.base} ${minHeights.sm} ${minHeights.lg} ${alignContainer}`}
        >
          <div className={`text-white ${alignWrap}`}>
            {/* Title */}
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-extrabold leading-tight">
              {title}
            </h1>

            {/* Name + lines */}
            {(name || lines.length > 0) && (
              <div className="mt-4 sm:mt-6">
                {name && (
                  <h2 className="text-lg sm:text-xl lg:text-2xl font-semibold">
                    {name}
                  </h2>
                )}
                {lines.map((t, i) => (
                  <p
                    key={i}
                    className={`${
                      i === 0 ? "mt-1" : "mt-0.5"
                    } text-sm sm:text-base lg:text-lg text-white/90`}
                  >
                    {t}
                  </p>
                ))}
              </div>
            )}

            {/* CTA */}
            {buttonText && (
              <div className="mt-6 sm:mt-8">
                <button
                  type="button"
                  onClick={onButtonClick}
                  className="inline-flex items-center rounded-xl px-5 py-3 text-sm sm:text-base font-semibold text-gray-900 shadow-lg backdrop-blur transition
                             bg-amber-400 hover:bg-amber-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
                >
                  {buttonText}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Small-screen fade (optional) */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-16 sm:h-20 bg-gradient-to-t from-black/30 to-transparent sm:hidden" />
    </section>
  );
}

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* First Hero Section */}
      <HeroBlock
        bgImage={backgroundImage}
        ariaLabel="Motivational speaker and corporate trainer hero"
        align="left"
        title={
          <>
            Unlock Your Potential.{" "}
            <span className="block">Build Your Success.</span>
          </>
        }
        name="Baba V. Ohol"
        lines={[
          "Visionary Motivational Speaker & Corporate Trainer",
          "Managing Director, OGCS Private Limited",
        ]}
        buttonText="Start Your Transformation Now!"
        onButtonClick={() => navigate("/login")}
      />

      {/* Second Section */}
      <HeroBlock
        bgImage={secondImage}
        ariaLabel="GrowMax call to action"
        align="center"
        title={
          <>
            Continue Your Journey with{" "}
            <span className="whitespace-nowrap">GrowMax</span>
          </>
        }
        lines={[
          "“Empowering Growth and Success.”",
          "Join a community dedicated to personal and professional development.",
        ]}
        buttonText="Learn More"
        onButtonClick={() => navigate("/growmax")}
        minHeights={{
          base: "min-h-[48vh]",
          sm: "sm:min-h-[58vh]",
          lg: "lg:min-h-[70vh]",
        }}
      />

      {/* Best Selling Books / Blogs Section */}
      <Blogs />
    </>
  );
};

export default HeroSection;
